import PropTypes from 'prop-types';
import { breakpoints } from '@styles/index';
import imageHelper from '@utils/imageHelper';
import styled from 'styled-components';

const StyledHeader = styled.header`
  background: #fff;
  box-shadow: inset 0px -1px 0px rgba(60, 72, 82, 0.12);
  height: 72px;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  @media (max-width: ${breakpoints.tablet}) {
    width: 100%;
    height: 56px;
  }
`;

const Nav = styled.nav`
  width: 1136px;
  margin: auto;
  display: flex;
  align-items: center;
  height: 72px;
  @media (max-width: ${breakpoints.tablet}) {
    height: 56px;
    width: 728px;
    justify-content: space-between;
  }
  @media (max-width: ${breakpoints.mobile}) {
    width: 100%;
    padding: 0 16px;
  }
`;

const CloseIcon = styled.button`
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  @media (min-width: ${breakpoints.mobile}) {
    display: none;
  }
`;

const Header = ({ handleClose, showCloseButton }) => (
  <StyledHeader>
    <Nav>
      <div>
        <img
          src={imageHelper.getImage('logo.svg')}
          alt="logo"
          width="161"
          height="24"
        />
      </div>
      {showCloseButton ? (
        <CloseIcon onClick={handleClose}>
          <img
            width="24"
            height="24"
            alt="close"
            src={imageHelper.getImage('k12/close.png')}
          />
        </CloseIcon>
      ) : null}
    </Nav>
  </StyledHeader>
);

Header.propTypes = {
  handleClose: PropTypes.func,
  showCloseButton: PropTypes.bool
};

Header.defaultProps = {
  showCloseButton: false,
  handleClose: () => {}
};

export default Header;
